interface PageHeaderProps {
    title: string;
    rightContent?: React.ReactNode;
}

const PageHeader = ({ title, rightContent }: PageHeaderProps) => {
    return (
        <div className="px-8 pt-6 pb-4 flex-shrink-0">
            <div className="w-3/4 mx-auto bg-white rounded-lg border border-gray-200 px-6 py-4 flex items-center justify-between">
                <h1 className="text-xl font-bold text-brand-500 border-l-4 border-brand-500 pl-3">
                    {title}
                </h1>
                {rightContent}
            </div>
        </div>
    );
};

export default PageHeader;
